import { HTMLAttributeAnchorTarget } from 'react'

interface IBlobUtil {
  toString: (blob: Blob, encoding?: BufferEncoding) => Promise<string>

  toDataUrl: (blob: Blob) => Promise<string>

  download: (blob: Blob, filename?: string, target?: HTMLAttributeAnchorTarget) => void
}

const BlobUtil: IBlobUtil = {
  toString: (blob: Blob, encoding?: BufferEncoding): Promise<string> => {
    const reader = new FileReader()
    reader.readAsText(blob, encoding)
    return new Promise<string>((resolve, reject) => {
      reader.onload = (ev: ProgressEvent<FileReader>) => {
        if (ev.target?.result) {
          resolve(ev.target.result as string)
        } else {
          reject(new Error('Empty Result'))
        }
      }

      reader.onerror = (ev: ProgressEvent<FileReader>) => reject(ev.target?.error)
    })
  },

  toDataUrl: (blob: Blob): Promise<string> => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    return new Promise<string>((resolve, reject) => {
      reader.onload = (ev: ProgressEvent<FileReader>) => {
        if (ev.target?.result) {
          resolve(ev.target.result as string)
        } else {
          reject(new Error('Empty Result'))
        }
      }

      reader.onerror = (ev: ProgressEvent<FileReader>) => reject(ev.target?.error)
    })
  },

  download: (blob, filename, target): void => {
    const url = URL.createObjectURL(blob)
    var a = document.createElement('a')
    a.setAttribute('style', 'display: none')

    if (target) {
      a.setAttribute('target', target)
    }

    a.href = url

    if (filename) {
      a.download = filename
    }

    document.body.appendChild(a)
    a.click()

    // Delay revoking the URL to ensure the file download is initiated
    setTimeout(() => URL.revokeObjectURL(url), 1000)
    a.remove()
  },
}

export default BlobUtil
